import { PopperMenuProps } from '../PopperMenu';

export default function useStyle({
  minWidth,
  customMenuStyles,
  menuItemStyles,
  selectedItemStyles,
}: Pick<
  PopperMenuProps,
  'minWidth' | 'customMenuStyles' | 'menuItemStyles' | 'selectedItemStyles'
>) {
  const defaultMenuStyles = {
    '& .MuiPaper-root': {
      minWidth,
      boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
      borderRadius: '8px',
      padding: '10px',
      ...customMenuStyles,
    },
    '& .MuiPopover-paper': {
      maxHeight: '400px',
    },
  };

  const defaultMenuItemStyles = {
    fontSize: '14px',
    height: '36px',
    cursor: 'pointer',
    ...menuItemStyles,
  };

  const defaultSelectedItemStyles = {
    backgroundColor: '#ffffff',
    color: 'primary.main',
    '&:hover': {
      backgroundColor: '#EDECFD',
    },
    ...selectedItemStyles,
  };
  return {
    defaultMenuStyles,
    defaultMenuItemStyles,
    defaultSelectedItemStyles,
  };
}
